// Mirrors the WordPress plugin's `img('name.svg')` helper so components ported
// verbatim from the plugin can reference images by filename instead of mapping
// each one to a named @img export. Every file under assets/images is resolved
// at build time via Vite's glob import and keyed by its basename.
const modules = import.meta.glob('../assets/images/**/*.{svg,png,jpg,jpeg,webp,gif}', {
    eager: true,
    import: 'default',
});

const byName = {};
for (const path in modules) {
    const name = path.split('/').pop();
    byName[name] = modules[path];
}

export const img = (name) => byName[name] || '';
